import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const DesignEditorHeaderLeftSlot = ({ className, children }) => {
  const classes = classNames({
    'design-editor-header-left': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

DesignEditorHeaderLeftSlot.propTypes = propTypes;

export default DesignEditorHeaderLeftSlot;
